import { AppEnvironment } from '../constants/appEnvironment';
import { envVars } from './envVars';

export const axleEnvironment = envVars.axleEnvironment;

export const isProduction = axleEnvironment === AppEnvironment.PRODUCTION;
// export const isDevelopment = axleEnvironment === 'development';
// export const isStaging = axleEnvironment === 'staging';
export const isLocal = axleEnvironment === AppEnvironment.LOCAL;
// True only in the headless e2e build. Used to disable browser-event-driven
// behavior (e.g. focus/online query refetch) that fires spuriously under
// Playwright and races React 18 Suspense renders (FE-717).
export const isTest = axleEnvironment === AppEnvironment.TEST;
